import { GraphQLQueryClass } from "@bsm/component";
import { TUserStudent } from "@bsm/graphql";

export class StudentDetailsQuery implements GraphQLQueryClass<TUserStudent, TResponse> {
    public queryKey: string = "App.Bsm.UserStudentDetailsQuery.Details";
    public gql: string = `
        query($id: Float){
            userStudent(filter: { id: $id }){
                id
                user {
                    id
                    firstName
                    lastName
                    fullName
                    profilePicture {id}
                }
            }
        }
    `;
    variables?: any;

    constructor(variables?: any) {
        this.variables = variables;
    }

    mapFn(data: TResponse): TUserStudent {
        return data.userStudent;
    }
}

export type TResponse = {
    userStudent: TUserStudent;
};
